import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var FontType = /** @class */ (function (_super) {
    __extends(FontType, _super);
    function FontType() {
        var _this = _super.call(this) || this;
        console.warn('[FontType] not implemented');
        return _this;
    }
    FontType.classInitializer = null;
    FontType.classSymbols = null;
    FontType.instanceSymbols = null;
    // JS -> AS Bindings
    FontType.EMBEDDED = 'embedded';
    FontType.EMBEDDED_CFF = 'embeddedCFF';
    FontType.DEVICE = 'device';
    return FontType;
}(ASObject));
export { FontType };
